import { render, staticRenderFns } from "./CSsystem.vue?vue&type=template&id=2cb3ffa5&scoped=true&"
import script from "./CSsystem.vue?vue&type=script&lang=js&"
export * from "./CSsystem.vue?vue&type=script&lang=js&"
import style0 from "./CSsystem.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CSsystem.vue?vue&type=style&index=1&id=2cb3ffa5&scoped=true&lang=scss&"
import style2 from "./CSsystem.vue?vue&type=style&index=2&id=2cb3ffa5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb3ffa5",
  null
  
)

export default component.exports